export { default as appConfig } from './app-config';
export { staticUrls } from './static-urls';
export { SearchMode } from './search-type';
export {
  amplitudeEventsConfig,
  type amplitudeEventsConfigTypes,
} from './amplitude-events';
export {
  defaultDepartureCityCode,
  defaultDepartureCityNames,
} from './default-city';
export { MAIN_PAGE_NAVIGATION_LOADER_KEY } from './main-page-navigation';
